import React  from 'react';
import PropTypes from 'prop-types';

export default function StringInList(props) {
    return <div className="ui5-txt-default">{props.value}</div>;
}

StringInList.propTypes = {
    value: PropTypes.string
}